import { Helmet } from 'react-helmet-async';
import Breadcrumbs from 'components/Breadcrumbs';
import { useLocation } from 'react-router-dom';
import { Faqs as FaqsComponent } from 'components/Faqs';

const banner =
  'https://res.cloudinary.com/dwoubdppz/image/upload/v1751597767/oak-and-stone-remodel/bath/bath3.webp';

export const Faqs = () => {
  const location = useLocation();

  return (
    <div>
      <Helmet>
        <title>FAQs | Oak & Stone Construction</title>
        <meta
          name="description"
          content="Find answers to common questions about our home remodeling services. Learn about our process, materials, timeline, and more."
        />
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="FAQs | Oak & Stone Construction" />
        <meta
          property="og:description"
          content="Find answers to common questions about our home remodeling services. Learn about our process, materials, timeline, and more."
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/dwoubdppz/image/upload/v1751597767/oak-and-stone-remodel/bath/bath3.webp"
        />
        <meta property="og:url" content="https://oakandstoneremodel.com/faqs" />
        <meta property="og:type" content="website" />
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="FAQs | Oak & Stone Construction" />
        <meta
          name="twitter:description"
          content="Find answers to common questions about our home remodeling services. Learn about our process, materials, timeline, and more."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/dwoubdppz/image/upload/v1751597767/oak-and-stone-remodel/bath/bath3.webp"
        />
        <meta
          name="twitter:url"
          content="https://oakandstoneremodel.com/faqs"
        />
        <link rel="canonical" href="https://oakandstoneremodel.com/faqs" />
      </Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: 'Who we are',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'We value our relationships with clients and love to make your dreams become your reality. We have a passion for the highest quality and perfection in our work.'
              }
            },
            {
              '@type': 'Question',
              name: 'What we do',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'We specialize in design, custom millwork, interior remodeling, additions and custom home building.'
              }
            },
            {
              '@type': 'Question',
              name: 'Where we work',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'We work in the greater Wasatch Front area, covering Box Elder, Weber, Davis and Cache Counties.'
              }
            }
          ]
        })}
      </script>

      {/* FAQs Header */}
      <div className="h-[45vh] w-full relative">
        <div className="absolute top-0 left-0 z-10 w-full h-full">
          <div className="grid content-center w-full h-full">
            <h1 className="text-4xl text-center text-white uppercase">
              Frequently Asked Questions
            </h1>
            <div className="h-1 mx-auto my-6 bg-white w-60"></div>
            <div className="w-10/12 mx-auto mt-6 text-lg font-normal tracking-widest text-center text-white md:w-full">
              ANSWERS TO YOUR REMODELING QUESTIONS
            </div>
          </div>
        </div>
        <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-[35%]"></div>
        <img
          src={banner}
          className="flex-shrink-0 object-cover w-full h-full bg-no-repeat"
          alt="Oak and Stone Construction FAQ banner"
        />
        <Breadcrumbs pathname={location.pathname} />
      </div>

      <FaqsComponent />
    </div>
  );
};
